import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { renderTextWithLinks } from '../../utils/linkify';

/* Figma asset: Check component - checkbox with optional charge and extra description.
 * BugHerd #130/#131: required/optional 표기 표준화 — [필수]/[선택] 텍스트 prefix 폐기.
 *   required=true  → 라벨 뒤 빨간 별표(*) 인라인 노출
 *   optional=true  → 라벨 뒤 회색 "(optional)" 인라인 노출 (i18n: common.optional_inline)
 *   둘 다 false(default) → 기존 동작과 동일 (회귀 영향 0).
 * 두 prop 모두 false 가 기본값이라 기존 호출자(약관 외 일반 체크박스)는 그대로 동작. */
export default function CheckBox({
  checked, onChange, label, extraLabel, charge, chargeActive, disabled,
  required = false, optional = false,
  className = '',
}) {
  const { t } = useTranslation();
  const hasExtra = !!extraLabel;
  return (
    <label className={`flex ${hasExtra ? 'items-start' : 'items-center'} gap-2.5 cursor-pointer select-none transition-opacity ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'} ${className}`}>
      <Icon
        name={checked ? 'checkbox-on' : 'checkbox-off'}
        size={24}
        className={`shrink-0 ${hasExtra ? 'mt-[1px]' : ''} ${checked ? 'text-orange-500' : 'text-mono-400'}`}
      />
      <span className="flex-1 min-w-0">
        <span className="flex items-center gap-1 flex-wrap">
          <span className="text-2sm font-medium text-mono-900">
            {label}
            {required && <span className="text-red-500 ml-0.5" aria-hidden="true">*</span>}
          </span>
          {optional && !required && (
            <span className="text-xs font-normal text-mono-400">
              {t('common.optional_inline', { defaultValue: '(선택)' })}
            </span>
          )}
          {charge && (
            <span className={`text-2sm font-medium ${chargeActive ? 'text-orange-500' : 'text-mono-500'}`}>{charge}</span>
          )}
        </span>
        {extraLabel && (
          // #240: 줄바꿈(\n) 보존 + 설명 내 URL 을 새 창 링크로 렌더.
          <span className="block text-[13px] font-normal text-mono-600 mt-0.5 leading-relaxed break-keep whitespace-pre-line">
            {renderTextWithLinks(extraLabel)}
          </span>
        )}
      </span>
      {/* BugHerd #130: sr-only 입력에 HTML required 를 걸면 native 브라우저 "Please fill out this field"
          툴팁이 보이지 않는 요소에 anchored 되어 깨짐. ARIA 만 노출하고 검증은 호출처 JS 에 위임. */}
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} className="sr-only" aria-required={required || undefined} />
    </label>
  );
}
